import React from 'react';
import Panel from './Panel';
import Resume from '../../components/Panel/ResumeNew/Select';
//import Resume from '../../components/Panel/ResumeNew/';




const ResumePage = () => {

  return (
    <Panel>
      <div>
        <Resume />
      </div>
    </Panel>

  );
};

export default ResumePage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ResumePage.js
 **/